export default {
  enums: [
    { id: 'RETAIL_RETURN' },
    { id: 'REMOTE_SALE_RETURN' },
    { id: 'RECEIPT_RETURN' },
  ]
};